import { render, staticRenderFns } from "./IndexNormal.vue?vue&type=template&id=7996892d&"
import script from "./IndexNormal.vue?vue&type=script&lang=js&"
export * from "./IndexNormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports